export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0031.4aa9ed1d.webp";